import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import Moment from 'react-moment';
import ModalAuth from '../../patient/unitReserve/modalAuth';

import Loader from 'react-loader-spinner';

var Config = require('../../../config');

class ModalExtraction extends Component{
	constructor(props){
		super(props);

		this.state = {
			show: false,
			rhGroup:[],
		    lookup_group:"",
	    	lookup_rh:"",
	    	rh_group:"",
	    	donor:{
				donor:{},
				person:{},
				offer:{}
			},
			offers_id:"",
			group_test_id:"",
			lectina:'',
			lectinaValues:["1","2"],

			flagStart:false,
			flagFinished:false,
			fmd:"",
			searching:true,
			disableStartBtn:false,
			screen:"",
			don_no_validate_hue:{}

		}

		this.handleShow  = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.openAuth = this.openAuth.bind(this);
		this.goToEx = this.goToEx.bind(this);
		this.goToHc = this.goToHc.bind(this);
	}

	componentDidMount(){
		this.props.onRef(this);

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=DON_NO_VALIDATE_HUE&x=',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      don_no_validate_hue: response
		    });
		})
	}

	goToEx(e, offer_id, donor_id, donation_id, extraction_incident_id, caller_id){
		if(e !== null){
			e.preventDefault();
		}
		
		//this.props.history.push("/extractions/new/"+offer_id+'/'+donor_id);
		if(caller_id === undefined || caller_id !== ""){
			this.props.history.push(
	            "/extractions/new/"+offer_id+'/'+donor_id+
	            '/'+donation_id+'/'+extraction_incident_id+"/0/1");
		}else{
			this.props.history.push(
	            "/extractions/new/"+offer_id+'/'+donor_id+
	            '/'+donation_id+'/'+extraction_incident_id+"/"+caller_id+"/1");
		}
			
	}

	goToHc(e, offers_id, donor_id){
		if(e !== null){
			e.preventDefault();
		}

	   this.props.history.push("/clinic_history/"+offers_id+'/'+donor_id);
	    
	}


	handleShow(donor_id, offers_id, group_test_id, rh_group, screen){
		this.setState({
			show:true,
			group_test_id:group_test_id,
			offers_id: offers_id,
			donor_id:donor_id,
			lookup_group:"",
			lookup_rh:"",
			rh_group:"",
			donor:{
				donor:{},
				person:{},
				offer:{}
			},
			screen:screen
		});

		this.getDonor(donor_id, offers_id);


		this.props.socket.onerror = (e)=>{
			this.setState({disableStartBtn:true});
		}

		this.props.socket.onopen = (e)=>{
			//socket.send("FPReset");
			this.props.socket.send("initfp");
		}

		this.props.socket.onmessage = (event)=>{
			var res = JSON.parse(event.data);

			if(res.MachineName){
		    	console.log(res.MachineName);
		    }

			if (res.Mensaje){
		        console.log(res.Mensaje);
			}

			if(res.Error){
				if(res.Error === "No hay lector inicializado"){
					swal("Error", "No hay lector inicializado. Por favor verifique la conexión de su dispositivo y refresque la pagina", 'error');
				}else{
					swal("Error", res.Error, 'error');
				}
			}

			if(res.Fmd){
				this.setState({flagFinished:true,searching:true});
				fetch(Config.default.apiGateway.URL+'donors?id='+donor_id+'&huella='+res.Fmd, {
					method:'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json;charset=UTF-8'
					})
				})
				.then(res =>{
					if(res.ok){
						return res.json();

					}else{
						this.setState({
							searching:false
						});

					}
				})
				.catch(error => console.error("Error: ", error))
				.then(res => {
					if(res.res === true){
						var caller_id = undefined;
						var donation_id = "";
						var extraction_incident_id = "";
					
						this.props.offers.res.map((v, i)=>{
							if(v.caller !== null){
								if(v.caller.offers_id === offers_id){
									caller_id 				= v.caller.id;
									donation_id 			= v.donation_id;
									extraction_incident_id 	= v.extraction_incident_id;
								}
							}else{
								if(v.offers_id === offers_id){
									donation_id 			= v.donation_id;
									extraction_incident_id 	= v.extraction_incident_id;
								}
							}
						})

						if(screen === 'ext'){
							this.goToEx(event, offers_id, donor_id, donation_id, extraction_incident_id,caller_id);	
						}else{
							this.goToHc(event, offers_id, donor_id);
						}
						
					
					}else{

						setTimeout(function(){
							this.setState({
								flagFinished:false,
								flagStart:false,
							})	
						}.bind(this), 2000);

						swal("Error", "La huella no coincide con el donante", 'error');
					
					}
				})
			}
		}

	}

	startRead = ()=>{
		try{
			this.props.socket.send("FPReset");
			this.props.socket.send('get');
			this.setState({flagStart:true});
		}catch(error){
			swal("Error", "Lector de huella no identificado", 'error');
		}
	}

	getDonor(id, offers_id){
		this.waiting_modal.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donors?id='+id+'&offer_id='+offers_id, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json' 
			})
		})
		.then(response => response.json())
		.then(response => {
			this.waiting_modal.handleClose();
			this.setState({donor:response});

			if(response.donor.fingerprint === null){
				var caller_id = undefined;
				var donation_id = "";
				var extraction_incident_id = "";

				this.props.offers.res.map((v, i)=>{
					if(v.caller !== null){
						if(v.caller.offers_id === this.state.offers_id){
							caller_id 				= v.caller.id;
							donation_id 			= v.donation_id;
							extraction_incident_id 	= v.extraction_incident_id;
						}
					}else{
						if(v.offers_id === this.state.offers_id){
							donation_id 			= v.donation_id;
							extraction_incident_id 	= v.extraction_incident_id;
						}
					}
				})

				swal({
			        title: '¿Está seguro?',
			        text: '¿El Donador no cuenta con huella registrada, desea continuar?',
			        type: 'warning',
			        showCancelButton: true,
			        confirmButtonColor: '#DD6B55',
			        confirmButtonText: '¡Si, Continuar!',
			        cancelButtonText: '¡No, Cancelar!',
			        closeOnConfirm: true,
			        closeOnCancel: true
			    }, (isConfirm) => {
			        if (isConfirm) {
			        	if(this.state.screen === 'ext'){
			        		this.goToEx(null, this.state.offers_id, response.donor.id, 
								donation_id, extraction_incident_id,caller_id);	
			        	}else{
			        		this.goToHc(null, this.state.offers_id, response.donor.id);
			        	}
			          	
						this.handleClose();
			        }
			    });
				
				
			}
		})
	}

	handleClose(){
		this.setState({
			show: false,
			rhGroup:[],
		    lookup_group:"",
	    	lookup_rh:"",
	    	rh_group:"",
	    	donor:{
				donor:{},
				person:{},
				offer:{}
			},
			offers_id:"",
			group_test_id:"",
			lectina:'',
			lectinaValues:["1","2"],

			flagStart:false,
			flagFinished:false,
			fmd:"",
			searching:true,
			disableStartBtn:false,
			screen:""
		});

		//this.props.socket.close();
	}

	openAuth(){
		//var screen = this.props.
		this.modal_auth.handleShow(this.state.donor_id, null, this.state.screen);
	}

	render(){
		const { t } = this.props;

		return (
			<div>
				<Modal dialogClassName="custom-modal" show={this.state.show} onHide={this.handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>Confirmar Huella</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
							<fieldset>
								<legend style={{fontSize:"1.2em"}}>
									{
										this.state.donor.person.lastname1  +' '+ 
									 	this.state.donor.person.lastname2 +' '+
									 	this.state.donor.person.names 
									}
								</legend>

								<div className="col-xs-12 col-md-7">
									<div className="row form-group">
										<div className="col-xs-6">
											{this.state.donor.person.photo !== null && this.state.donor.person.photo !== undefined?
												<img style={{height:'100px',width:'94px'}} src={'data:image/jpeg;base64,'+this.state.donor.person.photo} alt="Donor"/>
												:<img style={{height:'100px',width:'94px'}} src="../../../default_user.jpg" alt="USER"/>
											}
										</div>

										<div className="col-xs-6" style={{padding:'0px'}}>
								        	<span style={{fontSize:'.7em',fontWeight:'bold'}}>
								        		{t('content.offers.form.last_donation')}
								        	</span><br/>
								        	<span className="color-font" style={{fontSize:'.7em'}}>
								        		<Moment format="DD/MM/YYYY">{this.state.donor.offer.date}</Moment>
								        	</span><br/>
								        	<div style={{padding:'0px'}}>
									        	<span className="color-font" style={{fontSize:'.7em'}}>
									        		{this.state.donor.offer.donation_type}
									        	</span><br/>
									        	<span className="color-font" style={{fontSize:'.7em'}}>
									        		{this.state.donor.offer.extraction_type}
									        	</span>
									        </div>
							        	</div>
									</div>

									<div className="row form-group">
										<div className="col-xs-12">
											<span >
												<div className="col-xs-12 col-md-7">
													{t('content.modal_hc.birthday')}: 
												</div>
												<div className="col-xs-12 col-md-5">
													<Moment format="DD/MM/YYYY">{this.state.donor.person.birthday}</Moment>
												</div>
											</span>
										</div>

										<div className="col-xs-12">
											<span >
												<div className="col-xs-12 col-md-7">
													{t('content.modal_hc.donor_number')}: 
												</div>
												<div className="col-xs-12 col-md-5">
													{this.state.donor.donor.donor_number}
												</div>
											</span>
										</div>

										<div className="col-xs-12">
											<label className="btn-info" style={{margin:"0.5em", padding:"0.5em", borderRadius:"5px"}}>{this.state.donor.person.sex}</label>
											
										</div>
									</div>

								</div>

								<div className="col-xs-12 col-md-5">
									<div className="row form-group">
										<div className="col-xs-12">
											{this.state.flagStart ?
												<div>
													{this.state.flagFinished}
													{ !this.state.flagFinished ?
														<div style={{textAlign:"center"}}>
															<label>COLOQUE SU HUELLA</label>
														</div>
													  : <div style={{textAlign:"center"}}>
													  		{this.state.searching ?
													  		<div>
													  			<label>BUSCANDO COINCIDENCIAS</label>
														  		<div>
															  		<Loader
															  			type="Oval"
															  			color="#64B5F6"
															  			height={80}
															  			width={80}
															  		/>
																</div>
															</div>
															:<label>NO SE ENCONTRÓ NINGUNA COINCIDENCIAS</label>
															}
														</div> 
													}
												</div>
											:null }
										</div>
									</div>

									<div style={{textAlign:"center"}}>
										{!this.state.flagFinished && !this.state.flagStart ?
											<RaisedButton label="Iniciar Lectura" className="action-btn" 
												onClick={this.startRead} primary={true} disabled={this.state.disableStartBtn} />
										:null}
									</div>

									{this.state.don_no_validate_hue.value !== 'NO' &&
										<div style={{textAlign:"center", marginTop:'10px'}}>
											{!this.state.flagFinished && !this.state.flagStart ?
												<RaisedButton label="Saltar Validación" className="action-btn" 
													onClick={this.openAuth} primary={true} 
												 />
											:null}
										</div>
									}
								</div>
							</fieldset>
						</div>
					</Modal.Body>
					<Modal.Footer>
			        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
			        </Modal.Footer>
				</Modal>

				<ModalAuth {...this.props} onRef={ref => (this.modal_auth = ref)} 
					screen={this.state.screen} 
					goToHc={this.goToHc}
					goToEx={this.goToEx}
					handleClose={this.handleClose}
					offers_id={this.state.offers_id}
				/>
				<WaitingModal {...this.props} onRef={ref=>this.waiting_modal = ref} />
			</div>
		)
	}
}

export default ModalExtraction;